import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "border-b border-gray-200 px-4 py-4 sm:flex sm:items-center sm:justify-between lg:px-6" }
const _hoisted_2 = { class: "flex min-w-0" }
const _hoisted_3 = { class: "text-lg leading-6 text-gray-900 truncate" }
const _hoisted_4 = { class: "mt-4 flex sm:mt-0 sm:ml-4" }
const _hoisted_5 = {
  class: "flex",
  "aria-label": "HeaderMenu"
}
const _hoisted_6 = { class: "flex items-center space-x-6" }
const _hoisted_7 = {
  key: 0,
  class: ""
}
const _hoisted_8 = ["href"]
const _hoisted_9 = ["src"]
const _hoisted_10 = {
  key: 0,
  class: "bg-black w-full h-1 rounded-tl rounded-tr absolute -bottom-4"
}

import { ChevronLeftIcon } from "@heroicons/vue/24/solid";
import { useRouter } from 'vue-router';
import AuthService from "@/classes/AuthService";
import AdminData from '@/classes/AdminData';
import { computed } from 'vue';
import { useNetworkStore } from '@/store/network';

interface generalNavType {
    name: string,
    href: string,
    icon: any,
    allowed: boolean
}


export default /*@__PURE__*/_defineComponent({
  __name: 'TopNavigation',
  props: {
    title: String,
    backUrl: {
        type: String,
        default: null,
    },
    showBack: {
        type: Boolean,
        default: false,
    },
},
  setup(__props) {

const router = useRouter();
const networkStore = useNetworkStore();

const currentRoutePath = router.currentRoute.value.path;
const getLoggedAdmin = computed(() => AdminData.getAdmin()) 
const isNetworkAvailable = computed(() => networkStore.isNetworkAvailable);

const props = __props;

const goBack = () => {
    const url = props.backUrl;
    router.replace(url);
}

const navigation: generalNavType[] = computed(() =>[
    {
        name: "Profile",
        href: getLoggedAdmin.value ? `/profile/${getLoggedAdmin?.value.id}` : '',
        icon: "/assets/icons/nav/ic-nav-user.svg",
        allowed:
            isNetworkAvailable.value &&
            window.$hasPermission('update-account-profile')
    },
    {
        name: "Notification",
        href: "/notifications",
        icon: "/assets/icons/nav/ic-nav-notification.svg",
        allowed:
            isNetworkAvailable.value &&
            window.$hasPermission('receive-system-notifications')
    }
]);

const logout = () => {
    AuthService.logout()
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (__props.showBack)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              onClick: goBack,
              class: "border border-transparent text-xs text-gray-600 hover:text-gray-300 focus:outline-none mr-4"
            }, [
              _createVNode(_unref(ChevronLeftIcon), { class: "h-5 w-5" })
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("h1", _hoisted_3, _toDisplayString(__props.title), 1)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(navigation.value, (item) => {
              return (_openBlock(), _createElementBlock("div", { key: item }, [
                (item.allowed)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                      _createElementVNode("a", {
                        href: item.href,
                        class: _normalizeClass(["relative", [
                                    _unref(currentRoutePath) == item.href
                                    ? 'text-primary-700'
                                    : 'text-gray-500 hover:text-gray-400 dark:text-white'
                                ]])
                      }, [
                        _createElementVNode("img", {
                          src: item.icon,
                          class: _normalizeClass([ _unref(currentRoutePath) == item.href ? '' : 'opacity-40', 'h-7 w-7' ])
                        }, null, 10, _hoisted_9),
                        (_unref(currentRoutePath) == item.href)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_10))
                          : _createCommentVNode("", true)
                      ], 10, _hoisted_8)
                    ]))
                  : _createCommentVNode("", true)
              ]))
            }), 128)),
            (isNetworkAvailable.value)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  onClick: logout
                }, [...(_cache[0] || (_cache[0] = [
                  _createElementVNode("div", { class: "cursor-pointer" }, [
                    _createElementVNode("img", {
                      src: "/assets/icons/nav/ic-nav-logout.svg",
                      class: "w-7 h-7"
                    })
                  ], -1)
                ]))]))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ])
  ]))
}
}

})